<template>
  <!-- 添加或修改业务对话框 -->
  <el-dialog
    :title="title"
    :visible.sync="open"
    width="700px"
    :close-on-click-modal="false"
    append-to-body
  >
    <el-form ref="track" v-model="track">
      <el-row>
        <el-form-item label="风险预警等级" label-width="150px" :required="true">
          <el-select
            v-model="track.riskWarning"
            placeholder="请选择"
            clearable
            filterable
            style="width:350px"
          >
            <el-option label="高风险" value="1"></el-option>
            <el-option label="中风险" value="2"></el-option>
            <el-option label="低风险" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题及意见" label-width="150px" :required="true">
          <el-input v-model="track.advice" style="width:350px" type="textarea" :rows="10" />
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { makeTrackResult } from "@/api/trackMonth";
export default {
  name: "trackMake",
  data() {
    return {
      // 弹出层标题
      title: "审核", // 是否显示弹出层
      open: false, // 表单参数
      track: { id: "", courseId: "" },
    };
  },
  created() {},
  methods: {
    init(id, courseId) {
      this.open = true;
      this.track.id = id;
      this.track.courseId = courseId;
    },
    cancel() {
      this.open = false;
    } /** 提交按钮 */,
    submitForm() {
      makeTrackResult(this.track).then((res) => {
        if (res.code == 0) {
          this.$message.success("审核完成");
          this.track = {};
          this.open = false;
          this.$emit("childEvent");
        } else {
          this.$notify({
            title: "失败",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
  },
};
</script>